import { render, staticRenderFns } from "./LaIntroduce.vue?vue&type=template&id=973155ba&scoped=true&"
import script from "./LaIntroduce.vue?vue&type=script&lang=js&"
export * from "./LaIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./LaIntroduce.vue?vue&type=style&index=0&id=973155ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973155ba",
  null
  
)

export default component.exports